import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { Component } from "react";
import {
  fetchServiceRequestByPropertyIdUserIdRole,
} from "../../store/actions/serviceRequests";
import { selectServiceRequests } from "../../store/selectors/serviceRequests";
import ServiceRequestsTable from "../../components/ServiceRequestsTable/ServiceRequestsTable_legacy";
import { setSearch, clearSearch } from "../../store/actions/search";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import Loader from "../../components/Loader";
import { selectLoader } from "../../store/selectors/loader";
import { PATHS } from "../../common/constants";
import { fetchPropertyServiceRequestCSVExportDownloadList } from "../../store/actions/csvExport";

class PropertyServiceRequests extends Component {
  state = {
    searchString: "",
  };
  componentDidMount() {
    this.refreshServiceRequests();
  }

  loadMoreServiceRequest = async () => {
    const {
      user,
      fetchServiceRequestByPropertyIdUserIdRole,
      paginationCount,
      property,
    } = this.props;
    if (user && user.id) {
      let role = user.roles[0].role.name;
      fetchServiceRequestByPropertyIdUserIdRole(
        property.id,
        user.id,
        role,
        paginationCount + 1,
        this.state.searchString
      );
    }
  };

  refreshServiceRequests = () => {
    const { property, fetchServiceRequestByPropertyIdUserIdRole, user } =
      this.props;
    fetchServiceRequestByPropertyIdUserIdRole(
      property.id,
      user.id,
      user.roles[0].role.name,
      1,
      ""
    );

    this.props.clearSearch();
  };

  search = async (text) => {
    this.setState({ searchString: text });
    const { user, fetchServiceRequestByPropertyIdUserIdRole, property } =
      this.props;

    if (user && user.id) {
      let role = user.roles[0].role.name;
      fetchServiceRequestByPropertyIdUserIdRole(
        property.id,
        user.id,
        role,
        1,
        text,
        true
      );
    }
  };

  downloadCSV() {
    const { fetchPropertyServiceRequestCSVExportDownloadList, user, property } =
      this.props;
    fetchPropertyServiceRequestCSVExportDownloadList(
      property.id,
      user.id,
      user.roles[0].role.name,
      this.state.searchString
    );
  }

  render() {
    const { property, serviceRequests, loader } = this.props;
    return loader ? (
      <Loader />
    ) : (
      <ServiceRequestsTable
        download={() => this.downloadCSV()}
        serviceRequests={serviceRequests}
        onSearch={(e) => this.search(e.target.value.trim())}
        serviceRequest={{ property_id: property.id, propertyId: property.id }}
        loadServiceRequest={this.loadMoreServiceRequest}
        from="Property"
        navigateTo={PATHS.PROPERTIES_VIEW.replace(":id", property.id)}
        propertyId={property.id}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    paginationCount: state.paginationCount.count,
    pageCount: state.serviceRequestStatusPageCount.pageCount,
    serviceRequests: selectServiceRequests(state),
    user: selectAuthenticatedUser(state),
    loader: selectLoader(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchServiceRequestByPropertyIdUserIdRole:
        fetchServiceRequestByPropertyIdUserIdRole,
      // onFetchServiceRequestStatusCount:fetchServiceRequestStatusCount,
      setSearch,
      clearSearch,
      fetchPropertyServiceRequestCSVExportDownloadList:
        fetchPropertyServiceRequestCSVExportDownloadList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyServiceRequests);
